import { initial } from "lodash";
import React, { useState, useEffect } from "react";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Form,
	FormGroup,
	Label,
	Input,
} from "reactstrap";

export default function SeniorReviewModal({
	isOpen,
	initialData,   // { name, dob, mobile, courses: [] }
	onClose,        // () => void
	onConfirm,      // (payload) => void
}) {
	const [form, setForm] = useState({
		name: "",
		dob: "",
		mobile: "",
		courses: [],
	});

	useEffect(() => {
		if (isOpen) {
			setForm({
				name: initialData?.name || "",
				dob: initialData?.dob || "",
				mobile: initialData?.mobile || "",
				courses: Array.isArray(initialData?.courses) ? initialData.courses : [],
			});
		}
	}, [isOpen, initialData]);

	const onChange = (key, value) => setForm((s) => ({ ...s, [key]: value }));

	return (
		<Modal isOpen={isOpen} centered size="md">
			<ModalHeader>Confirm Learner Details</ModalHeader>
			<ModalBody>
				<Form>
					<FormGroup>
						<Label for="sr_name">Learner Name</Label>
						<Input
							id="sr_name"
							value={form.name}
							onChange={(e) => onChange("name", e.target.value)}
							placeholder="Enter learner full name"
						/>
					</FormGroup>

					<FormGroup>
						<Label for="sr_dob">Date of Birth</Label>
						<Input
							id="sr_dob"
							type="date"
							value={(form.dob || "").slice(0, 10)}
							onChange={(e) => onChange("dob", e.target.value)}
						/>
					</FormGroup>

					<FormGroup>
						<Label for="sr_mobile">Mobile</Label>
						<Input
							id="sr_mobile"
							value={form.mobile}
							onChange={(e) => onChange("mobile", e.target.value)}
							placeholder="Enter contact number"
						/>
					</FormGroup>

					<FormGroup>
						<Label for="sr_course">Course Selected</Label>
						<Input
							id="sr_course"
							readOnly
							value={
								form.courses && form.courses.length > 0
									? form.courses.join(", ")
									: "-"
							}
						/>
					</FormGroup>
				</Form>
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={onClose}>
					Back
				</Button>
				<Button
					color="primary"
					onClick={() => onConfirm?.(form)}
				>
					Continue
				</Button>
			</ModalFooter>
		</Modal>
	);
}
